import { render, staticRenderFns } from "./ItemProfileLayout.vue?vue&type=template&id=7509152a&"
import script from "./ItemProfileLayout.vue?vue&type=script&lang=js&"
export * from "./ItemProfileLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports